/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * this type is for badge reward
 */
export type BadgeEventReward = {
    type: BadgeEventReward.type;
    /**
     * id of badge will acquire
     */
    badgeId: number;
    rankWillAcquire: number;
};
export namespace BadgeEventReward {
    export enum type {
        BADGE_REWARD = 'badge_reward',
    }
}

